import {Component, NgZone} from '@angular/core';
import { UpdateVersionService } from './core/services/update-version/update-version.service';
import { UiService } from './shared/services/ui.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  title = 'angular-fe';

  showLoading: boolean = false;

  constructor(updateVersion: UpdateVersionService, private uiService: UiService, private ngZone: NgZone) {
    updateVersion.checkForUpdates();

    this.uiService.showLoading.subscribe(
      value => {
        this.ngZone.run(() => this.showLoading = value)
      }
    );
  }
}
